import http from './http';

const getRedirects = (value, page) => {
  const q = value ? `&query=${encodeURIComponent(value)}` : '&query=';
  return http.get(`/redirects/?page_size=10&page_nbr=${page}&sort_field=created_at&sort_type=desc&empty=true${q}`);
};

const createRedirect = (payload) => {
  return http.post(`/redirects`, payload);
};

export default { getRedirects, createRedirect };
export { getRedirects, createRedirect };
